import { ProjectDetailsScreenAdhaMobile } from '@/modules/property-details/ProjectDetailsScreenAdhaMobile';

export default function ProjectDetailsRoute() {
    return <ProjectDetailsScreenAdhaMobile />;
}
